import { render, staticRenderFns } from "./addParaseAnalisis.vue?vue&type=template&id=64ea71a9&scoped=true"
import script from "./addParaseAnalisis.vue?vue&type=script&lang=js"
export * from "./addParaseAnalisis.vue?vue&type=script&lang=js"
import style0 from "./addParaseAnalisis.vue?vue&type=style&index=0&id=64ea71a9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ea71a9",
  null
  
)

export default component.exports